import script from "./SelectedRequirementsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedRequirementsPanel.vue?vue&type=script&setup=true&lang=js"

import "./SelectedRequirementsPanel.vue?vue&type=style&index=0&id=b7706088&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7706088"]])

export default __exports__